import { ErrorHandler, ErrorType } from '@/components/error-handler';
import { useMemo } from 'react';
import { BaleInboundError } from './context';
import { useBaleInboundContext } from './hook';

const getErrorConfig = (error: BaleInboundError): ErrorType | null => {
	switch (error) {
		case 'LOAD_NOT_FOUND':
			return {
				type: 'error',
				style: 'full',
				title: 'Load not found',
				details:
					'This bale could not be matched to a load. Please scan another bale or enter load details manually.',
			};

		default:
			return null;
	}
};

/**
 * Error handler specifically for the bale inbound workflow.
 * Maps workflow-specific errors to user-friendly messages and displays them using the ErrorHandler component.
 *
 * Note: This workflow context doesn't currently have dedicated error state management.
 * To fully implement this, add error state to the BaleInboundContext similar to other workflows.
 */
export const BaleInboundErrorHandler = () => {
	// Note: The current bale inbound context doesn't have error state management
	// This is a placeholder implementation for when error state is added

	// Placeholder - this would need actual error state from context
	const { error, setError } = useBaleInboundContext();
	const errorConfig = useMemo(() => {
		return getErrorConfig(error);
	}, [error]);

	return <ErrorHandler error={errorConfig} setError={() => setError(null)} />;
};
